import { z } from 'zod';

export const password = z
	.string({
		required_error: 'Password is required'
	})
	.min(8, {
		message: 'Password must be at least 8 characters'
	})
	.regex(/[0-9]/, {
		message: 'Password must contain at least 1 number'
	})
	.regex(/[A-Z]/, {
		message: 'Password must contain at least 1 uppercase character'
	})
	.regex(/[^\w\s]|[_]/, {
		message: 'Password must contain at least 1 special character'
	});
